import { styled } from '../../config/stitches'

export const ErrorText = styled('span', {
  fontSize: '11px',
  lineHeight: '12px',
  fontWeight: 500,
  color: '$red1000',
  display: 'flex',
  width: '100%',
  padding: '0px',
  marginTop: '8px',
  variants: {
    secondary: {
      true: {
        color: '$red0700'
      }
    }
  }
})
